import { render, staticRenderFns } from "./DatasetCrudHeaderCell.vue?vue&type=template&id=3376093c"
import script from "./DatasetCrudHeaderCell.vue?vue&type=script&lang=js"
export * from "./DatasetCrudHeaderCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports